import { URLS } from '@wix/da-url';
export const SYMBOLS_LIST = [
    {
        title: 'userSymbolsPopup.v2.symbols.core_access.title',
        description: 'userSymbolsPopup.v2.symbols.core_access.description',
        userSymbol: 'core_access',
        moreUrl: 'https://www.deviantart.com/core-membership/?point=username_symbol_modal'
    },
    {
        title: 'userSymbolsPopup.v2.symbols.core_plus.title',
        description: 'userSymbolsPopup.v2.symbols.core_plus.description',
        userSymbol: 'core_plus',
        moreUrl: 'https://www.deviantart.com/core-membership/?point=username_symbol_modal'
    },
    {
        title: 'userSymbolsPopup.v2.symbols.core_pro.title',
        description: 'userSymbolsPopup.v2.symbols.core_pro.description',
        userSymbol: 'core_pro',
        moreUrl: 'https://www.deviantart.com/core-membership/?point=username_symbol_modal'
    },
    {
        title: 'userSymbolsPopup.v2.symbols.core_pro_plus.title',
        description: 'userSymbolsPopup.v2.symbols.core_pro_plus.description',
        userSymbol: 'core_pro_plus',
        moreUrl: 'https://www.deviantart.com/core-membership/?point=username_symbol_modal'
    },
    {
        title: 'userSymbolsPopup.v2.symbols.hell.title',
        description: 'userSymbolsPopup.v2.symbols.hell.description',
        userSymbol: 'hell'
    },
    {
        title: 'userSymbolsPopup.v2.symbols.senior.title',
        description: 'userSymbolsPopup.v2.symbols.senior.description',
        userSymbol: 'senior',
        moreUrl: 'https://www.deviantartsupport.com/en/article/how-can-i-become-a-senior-member'
    },
    {
        title: 'userSymbolsPopup.v2.symbols.volunteer.title',
        description: 'userSymbolsPopup.v2.symbols.volunteer.description',
        userSymbol: 'volunteer',
        moreUrl: 'https://www.deviantartsupport.com/en/article/how-can-i-apply-to-become-a-community-volunteer-for-deviantart'
    },
    {
        title: 'userSymbolsPopup.v2.symbols.admin.title',
        description: 'userSymbolsPopup.v2.symbols.admin.description',
        userSymbol: 'admin',
        moreUrl: URLS.ABOUT
    }
];

//# sourceMappingURL=constants.js.map